module.exports = __webpack_public_path__ + "img/pinpai.1b27aa0e.png";